const serviceName = 'rapidoo';

export const EVENTS = {
  USER: {
    LOGIN: 'user.login',
    LOGIN_SUCCESS: 'user.login_success',
    LOGIN_ERROR: 'user.login_error',
    REGISTER: 'user.register',
    REGISTRING: 'user.registring',
    REGISTER_SUCCESS: 'user.register_success',
    REGISTER_ERROR: 'user.register_error',
    REGISTRATION_STEP_CHANGED: 'user.registration_step_changed',
    PREVIOUS_REGISTRATION_STEP: 'user.previous_registration_step',
    START_REGISTRATION_STEPPER: 'user.start_registration_stepper',
    START_CANCEL_REGISTRATION: 'user.start_cancel_registration',
    CONFIRM_CANCEL_REGISTRATION: 'user.confirm_cancel_registration',
    OTP_GENERATED: 'user.otp_generated',
    LOGOUT: 'user.logout',
    REGISTRATION_COUNTRY: 'user.select_registration_country',
    REGISTRATION_PHONE_COUNTRY: 'user.select_registration_phone_country',
    UPDATE: 'user.update',
    UPDATE_SUCCESS: 'user.update_success',
    UPDATE_ERROR: 'user.update_error',
    REFRESH_DATA: 'user.refresh_data',
    REFRESH_DATA_SUCCESS: 'user.refresh_data_success',
    REFRESH_DATA_ERROR: 'user.refresh_data_error',
    SAVE_BIRTHDAY: 'user.save_birthday',
    SAVE_BIRTHDAY_SUCCESS: 'user.save_birthday_success',
    SAVE_BIRTHDAY_ERROR: 'user.save_birthday_error',
    BIRTHDAY_DIALOG_SHOWN: 'user.birthday_dialog_shown',
    SKIP_BIRTHDAY: 'user.skip_birthday',
    FAVORITE_TOGGLE_REST: 'user.favorite_toggle_rest',
    FAVORITE_TOGGLE_DISH: 'user.favorite_toggle_dish',
    FAVORITE_SUCCESS: 'user.favorite_success',
    FAVORITE_ERROR: 'user.favorite_error',
    FAVORITES_LOAD: 'user.favorites_load',
    FAVORITES_LOAD_SUCCESS: 'user.favorites_load_success',
    FAVORITES_LOAD_ERROR: 'user.favorites_load_error'
  },

  LEGACY_MIGRATION: {
    DETECTED: 'legacy_migration.detected',
    START_MIGRATION: 'legacy_migration.start_migration',
    SKIP_MIGRATION: 'legacy_migration.skip_migration',
    CONFIRM_SKIP: 'legacy_migration.confirm_skip',
    MIGRATION_COMPLETE: 'legacy_migration.complete',
    MIGRATION_FAILED: 'legacy_migration.failed'
  }
};

export const ENDPOINTS = {
  USER: {
    LOGIN: '/user/rapidoo/login?group=ultraxeno',
    REGISTER: '/user/rapidoo/register?group=ultraxeno',
    UPDATE: '/user/rapidoo/update?group=ultraxeno',
    PROFILE: (userId) => `/user/rapidoo/${userId}?group=ultraxeno`,
    REFRESH_DATA: `/user/rapidoo/{userId}?group=ultraxeno`,
    GET_ALL: (phoneNumber) => `/user/rapidoo/all?group=ultraxeno&phoneNumber=${phoneNumber}`,
    GET_BY_EMAIL: (email) => `/user/rapidoo/all?group=ultraxeno&email=${encodeURIComponent(email)}`,
    OTP: '/user/rapidoo/otp?numberOfDigits=5&requestId=',
    SAVE_BIRTHDAY: '/user/rapidoo/birthday?group=ultraxeno',
    FAVORITES: {
      TOGGLE: '/favorite/toggle?group=ultraxeno',
      LIST: '/favorite/list?group=ultraxeno'
    }
  }
};


export const AUTH = {
  SERVICE_NAME: serviceName
};
